import request from '../request'

// 新增
export function newZhuli(courseId, activityId) {
  const url = '/assistance/assist'
  return request.get(url, {
    params: {
      // model: 0,
      course_id: courseId,
      activity_id: activityId
    }})
}

/**
 * 获取
 * @param courseId 课程id
 * @param activityId 开团id
 * @param activityAssistanceId 团拥有者的团id
 * @returns {AxiosPromise<any>}
 */
export function getZhuli(courseId, activityId, activityAssistanceId) {
  const url = '/assistance/assist'
  return request.get(url, {
    params: {
      model: 1,
      course_id: courseId,
      activity_id: activityId,
      activity_assistance_id: activityAssistanceId || ''
    }})
}

// 新增
export function newZhuli2(courseId, activityId) {
  const url = '/assistance/assist'
  return request({
    method: 'get',
    url: url,
    params: {
      // model: 0,
      course_id: courseId,
      activity_id: activityId
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/activity/zhuli.js